import { useMarket } from "@app/_context";

import { isAdyenCheckoutEnabled } from "@/config/checkout";

import { useCheckoutContext } from "../Checkout.hooks";
import { checkoutStore } from "../Checkout.store";
import CheckoutTextInput from "../CheckoutTextInput";
import CheckoutAddressHeading from "./CheckoutAddressHeading";
import CheckoutCountrySelect from "./CheckoutCountrySelect";
import CheckoutPhoneNumberInput from "./CheckoutPhoneNumberInput";
import CheckoutToggleDeliveryAddress from "./CheckoutToggleDeliveryAddress";
import CheckoutToggleLine2Address from "./CheckoutToggleLine2Address";

export default function CheckoutAddressFields() {
  const marketConfig = useMarket().state.market;
  const { dictionary } = useCheckoutContext();
  const line2 = checkoutStore((state) => state.address.line2);
  const address = checkoutStore((state) => state.address);
  const hasLine2Address = checkoutStore((state) => state.hasLine2Address);

  if (isAdyenCheckoutEnabled({ marketConfig }) === false) {
    return (
      <>
        <CheckoutAddressHeading />
        <CheckoutCountrySelect name="country" label={dictionary.country} />
        <CheckoutTextInput
          name="zipCode"
          type="text"
          defaultValue={address.zipCode}
          placeholder={dictionary.zipCode}
          label={dictionary.zipCode}
        />
      </>
    );
  }

  return (
    <>
      <CheckoutAddressHeading />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.firstName}
        name="firstName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.lastName}
        name="lastName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.email}
        name="email"
        type="email"
      />
      <CheckoutPhoneNumberInput
        className="max-lg:col-span-2"
        label={dictionary.phoneNumber}
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.street}
        name="line1"
        type="text"
      >
        <CheckoutToggleLine2Address
          className="absolute right-4 top-3"
          data-testid="toggle-line2-address"
        >
          {dictionary.addLine2}
        </CheckoutToggleLine2Address>
      </CheckoutTextInput>
      {(line2 || hasLine2Address) && (
        <CheckoutTextInput
          className="max-lg:col-span-2"
          label={dictionary.co}
          name="line2"
          type="text"
        />
      )}
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.zipCode}
        name="zipCode"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.city}
        name="city"
        type="text"
      />
      <CheckoutCountrySelect name="country" label={dictionary.country} />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.companyNameIfApplicable}
        name="company"
        type="text"
      />
      <CheckoutToggleDeliveryAddress className="col-span-2" />
    </>
  );
}
